import React, { useState, useEffect } from 'react';
import { useTranslate } from 'react-polyglot';

import SelectControl from '../common/select';
import campaignService from '../../services/Campaign';
import DropInput from '../dropInput';
import Icon from '../icon';
import ErrorMessage from "../ErrorMessage/ErrorMessage";

import '@material/textfield/dist/mdc.textfield.css';
import '@material/floating-label/dist/mdc.floating-label.css';
import '@material/notched-outline/dist/mdc.notched-outline.css';
import '@material/line-ripple/dist/mdc.line-ripple.css';
import '@material/ripple/dist/mdc.ripple.css';
import '@rmwc/icon/icon.css';
import { Button } from '@rmwc/button';
import { DialogActions, DialogButton } from 'rmwc';
import ActionButtons from '../actionsDialog/ActionButtons';

function MigExp(props) {
    const [campaign, setCampaign] = useState(null);
    const [campaigns, setCampaigns] = useState([]);

    const t = useTranslate();

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        fetchCampaigns();
    }, [])

    function fetchCampaigns() {
        setIsLoading(true);
        campaignService.list(false)
            .then((campaingsResponse) => {
                const campaingsMapped = campaingsResponse.filter(c => c.id !== props.data.campaign.id)
                setCampaigns(campaingsMapped);
                setIsLoading(false);
            });
    }

    return (
        <>
        <div className={'coa-dialog-form coa-dialog-with-action-buttons'}>
            <DropInput
                creatableProps={{
                    menuPortalTarget: document.body,
                    styles: {
                        dropdownIndicator: base => ({...base, color: "#3487F0", paddingRight: '30px'}),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    },
                    isLoading: isLoading
                }}
                label="Crear un proyecto o agrega la experiencia a un proyecto existente"
                outlined
                className={'new-experience-file-input'}
                icon={<Icon name={'campaings'} className={'new-experience-file-input-icon'}/>}
                onChangeFn={e => {
                    setCampaign(e)
                    props.onChange({
                        campaign: {
                            id: e.id,
                            name: e.name
                        }
                    });
                }}
                data={campaigns}
                project={campaign}
            />
        </div>
        <ActionButtons
            cancelText={t('actions.cancel')}
            acceptText={t('actions.accept')}
            acceptDisabled={campaign === null}
            onClickCancel={(e) => {
                e.preventDefault();
                props.setOpen(false);
            }}
            onClickAccept={(e) => {
                e.preventDefault();
                props.setOpen(false);

                props.actionHandler({
                    value: {},
                    key: props.keyData,
                    campaign: {
                        id: campaign ? campaign.id : '',
                        name: campaign ? campaign.name : ''
                    }
                });
            }}
        ></ActionButtons>
        </>
    )
}

export default MigExp;